import rawCounties from "./data/counties.json";

/** Keep in sync with `DEFAULT_REGISTRATION_COUNTRY` in `crmPayload.ts`. */
const DEFAULT_JURISDICTION_COUNTRY = "United States";

/** Nested map: country → state → county names (legacy buxusweb / mobile data). */
type CountyTree = Record<string, Record<string, string[]>>;

const counties = rawCounties as CountyTree;

/** Country names for registration mailing / jurisdiction dropdowns (legacy counties.json). */
export function listRegistrationCountryNames(): string[] {
  return Object.keys(counties).sort((a, b) => a.localeCompare(b));
}

/** State/province names for a country (distinct from send-alert helpers that return label/value rows). */
export function listRegistrationStatesForCountry(country: string): string[] {
  const c = counties[country];
  if (!c) return [];
  return Object.keys(c)
    .filter((k) => Array.isArray((c as Record<string, unknown>)[k]))
    .sort((a, b) => a.localeCompare(b));
}

export function listRegistrationCountiesForState(country: string, state: string): string[] {
  const list = counties[country]?.[state];
  return Array.isArray(list) ? [...list].sort((a, b) => a.localeCompare(b)) : [];
}

export function defaultJurisdictionRow(): { country: string; state: string; county: string } {
  return { country: DEFAULT_JURISDICTION_COUNTRY, state: "", county: "" };
}
